// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"ba623ba0cefd5e0a","5285":"676ba3aca5fad6ed"}[chunkId] + ".css";
};